import React from 'react';

import { SectionHeadingProps } from './SectionHeadingProps';

import './styles.css';

const SectionHeading: React.FC<SectionHeadingProps> = ({
    text,
    textColor,
    margin,
    customClass
}) => {
    return (
        <h2 style={{ margin: margin }} className={`secHeading ${customClass || ''}`}>
            <span style={{color: textColor}} className='secHeading__text'>{text}</span>
        </h2>
    )
}

export default SectionHeading;